<template>
  <div>
    <group-card title="Lenders" icon="account_balance" padded>
      <template slot="actions">
        <md-button
          class="md-icon-button md-primary md-simple"
          @click="$router.push('/administration/lender/new/view')"
        >
          <md-icon>add</md-icon>
          <md-tooltip md-direction="top">Add New Lender</md-tooltip>
        </md-button>
        <!-- TODO enable this feature-->
        <!--        <md-button class="md-icon-button md-primary md-simple"-->
        <!--                   @click="$router.push('/administration/broker/new')">-->
        <!--          <md-icon>add</md-icon>-->
        <!--          <md-tooltip md-direction="top">Add New Lender</md-tooltip>-->
        <!--        </md-button>-->
        <loading-icon-button
          @click="getLenders(true)"
          tooltip="Refresh"
          :loading="progress_indicator.lender_list"
        >
          cached
        </loading-icon-button>
      </template>
      <div data-app>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          :headers="lenderHeaders"
          :items="lenders"
          :search="search"
          item-key="name"
          :items-per-page="10"
          class="elevation-0 broker_table"
          :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'first_page',
                    lastIcon: 'last_page',
                    prevIcon: 'skip_previous',
                    nextIcon: 'skip_next'}"
          :loading="progress_indicator.lender_list"
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.push_to_xero="{ item }">
            <md-button class="md-just-icon md-primary md-simple" v-if="item.push_to_xero"
                       @click="toggleFlag(item.id, 'xero', 'disable')">
              <md-icon>done</md-icon>
              <md-tooltip md-direction="top">Click to uncheck</md-tooltip>
            </md-button>
            <md-button class="md-just-icon md-primary md-simple" v-else
                       @click="toggleFlag(item.id, 'xero', 'enable')">
              <md-icon>close</md-icon>
              <md-tooltip md-direction="top">Click to check</md-tooltip>
            </md-button>
          </template>
          <template v-slot:item.show_in_reporting="{ item }">
            <md-button class="md-just-icon md-primary md-simple" v-if="item.show_in_reporting"
                       @click="toggleFlag(item.id, 'reporting', 'disable')">
              <md-icon>done</md-icon>
              <md-tooltip md-direction="top">Click to uncheck</md-tooltip>
            </md-button>
            <md-button class="md-just-icon md-primary md-simple" v-else
                       @click="toggleFlag(item.id,'reporting', 'enable')">
              <md-icon>close</md-icon>
              <md-tooltip md-direction="top">Click to check</md-tooltip>
            </md-button>
          </template>
          <template v-slot:item.is_floorplan="{ item }">
            <md-button class="md-just-icon md-primary md-simple" v-if="item.is_floorplan"
                       @click="toggleFlag(item.id, 'floorplan', 'disable')">
              <md-icon>done</md-icon>
              <md-tooltip md-direction="top">Click to uncheck</md-tooltip>
            </md-button>
            <md-button class="md-just-icon md-primary md-simple" v-else
                       @click="toggleFlag(item.id,'floorplan', 'enable')">
              <md-icon>close</md-icon>
              <md-tooltip md-direction="top">Click to check</md-tooltip>
            </md-button>
          </template>
          <template v-slot:item.actions="{ item }">
            <loading-icon-button
              @click="viewLender(item)"
              tooltip="Open"
            >
              launch
            </loading-icon-button>
          </template>
        </v-data-table>
      </div>
    </group-card>
    <group-card title="Refresh Assessments">
      <template slot="actions">
        <md-switch v-model="showAssessmentTool">Toggle Advance BA Tool</md-switch>
      </template>
      <div v-if="showAssessmentTool">
        <md-field>
          <label>Please enter Application ID seperated by a comma.</label>
          <md-textarea
            md-autogrow
            class="md-layout-item md-small-size-100 md-size-100"
            v-model="app_ids"
          ></md-textarea>
        </md-field>
        <br/>
        <loading-icon-text-button
          @click="refreshBA"
          tooltip="Refresh"
          class="md-layout-item md-size-20"
          icon="cache"
        >
          Refresh Assessment
        </loading-icon-text-button>
      </div>
    </group-card>
  </div>
</template>
<script>
import filters from "@/components/utils/filters";
import {GroupCard} from "@/components";
import {mapGetters} from "vuex";
import LoadingIconButton from '@/components/LoadingIconButton';
import ValidatedTextInput from "../components/ValidatedInput/ValidatedTextInput";
import LoadingIconTextButton from "../components/LoadingIconTextButton";
import WaitingDialog from "../components/Dialogs/WaitingDialog";
import ConfirmDialog from "../components/Dialogs/ConfirmDialog";

export default {
  components: {
    LoadingIconTextButton,
    ValidatedTextInput,
    GroupCard,
    LoadingIconButton,
  },
  data() {
    return {
      search: '',
      progress_indicator: {
        lender_list: false,
      },
      lenderHeaders: [
        {
          text: "ADP ID",
          align: 'center',
          sortable: true,
          value: 'adp_id'
        },
        {text: 'Lender Name', value: 'lender_name', align: 'center'},
        {text: 'Product Count', value: 'product_count', align: 'center'},
        {text: 'Brokers Count', value: 'brokers_count', align: 'center'},
        {text: 'Push To Xero', value: 'push_to_xero', align: 'center'},
        {text: 'Show In Reporting', value: 'show_in_reporting', align: 'center'},
        {text: 'Floorplan Lender', value: 'is_floorplan', align: 'center'},
        {text: 'Action', value: 'actions', align: 'center'},
      ],
      lenders: [],
      app_ids: "",
      currentId: "",
      showAssessmentTool: false,
    }
  },
  methods: {
    async toggleFlag(id, type, flag) {
      this.progress_indicator.lender_list = true;
      await this.$store.dispatch('toggle_lender_setting', {
        id: id,
        flag: flag,
        type: type,
      });
      this.getLenders(true);
      this.progress_indicator.lender_list = false;
    },
    async refreshBA() {
      //break app_ids based on ,
      let app_ids = this.app_ids.split(",");
      this.showProcessDialog("Processing...", "Please wait whilst the assessment results are being refreshed.");
      for (const id of app_ids) {
        this.currentId = id;
        await axios.post('/api/v1/assessment/batch/refresh', {
          application_id: id,
        });
      }
      if (this.$modal.submit) {
        this.$modal.submit();
        await this.showProcessDialog("Success", "The assessment results have been refreshed.", "confirm");
      }
    },
    async getLenders(force = false) {
      this.progress_indicator.lender_list = true;
      let response = await this.$store.dispatch('fetch_lender_list', force);
      this.lenders = response;
      this.progress_indicator.lender_list = false;
    },
    viewLender(item) {
      this.$router.push(`/administration/lender/${item.id}/view`);
    },
    async showProcessDialog(title, message, type = "waiting") {
      if (type == "waiting") {
        this.$modal.show(WaitingDialog, {
          title: title,
          message: message,
        });
      }
      if (type == "confirm") {
        this.$modal.show(ConfirmDialog, {
          title: title,
          message: message,
          confirmText: "Close",
        })
      }
    },
  },
  mounted() {
    this.getLenders();
  },
  computed: {
    ...mapGetters({
      savedBrokers: 'administrationBrokers',
    }),
  },
  filters: {
    ...filters,
  }
}
</script>
<style lang="scss" scoped>
.broker_table {
  table {
    td {
      text-align: center;
    }
  }

  .v-data-footer__select {
    display: none;
  }
}
</style>
